<template>
	<div class="ReDateRange">
		<el-date-picker
			:type="type"
			format="dd.MM.yyyy HH:mm"
			value-format="yyyy-MM-dd HH:mm:ss"
			:picker-options="{firstDayOfWeek:1}"
			:placeholder="start_placeholder"
			v-model="value.startDt"
			
			@change="onChange"
		>
		</el-date-picker>
		<span class="range_separator">{{range_separator}}</span>
		<el-date-picker
			:type="type"
			format="dd.MM.yyyy HH:mm"
			value-format="yyyy-MM-dd HH:mm:ss"
			:picker-options="{firstDayOfWeek:1}"
			:placeholder="end_placeholder"
			v-model="value.endDt"
			@change="onChangeEndDt"
		>
		</el-date-picker>
	</div>
</template>
<script>
/*
yyyy-MM-dd HH:mm:ss
 */
	import moment from 'moment';
	moment.locale('ru');

	import { DatePicker } from 'element-ui';
	export default {
		name: 'ReDateRange',
		components: {
			[DatePicker.name]: DatePicker,
		},
		props: {
			value: {
				type: Object,
				default() {	return {
					startDt: '',
					endDt:''
				}; }
			},
			range_separator:{
				type:String,
				default: '-'
			},
			start_placeholder:{
				type:String,
				default: 'С'
			},
			end_placeholder:{
				type:String,
				default: 'По'
			},
			type:{
				type:String,
				default: 'date'
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {
			onChange(evtDate){
				// this.value.endDt = this.$GVO.unlinkObject(moment(evtDate).add(23, 'hours').format('YYYY-MM-DD HH:mm:ss'));
				//04.10.2024 -- ранее тут было добавлние  3 часов -- почему 3 уже никто не помнит!
			},
			onChangeEndDt(evtDate){
				this.value.endDt = this.$GVO.unlinkObject(moment(evtDate).add(23, 'hours').add(59, 'minutes').format('YYYY-MM-DD HH:mm:ss'));
				//04.10.2024 -- этого кода не было, но люди не понимают, почему конечный период 00:00, ожидают по включительно 23:59
			}
		},
		mounted(){
			if(this.value.startDt == ''){
				this.value.startDt = this.$GVO.unlinkObject(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));
				this.value.endDt = this.$GVO.unlinkObject(moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));
				// this.value.endDt = this.$GVO.unlinkObject(moment(new Date()).add(3, 'hours').format('YYYY-MM-DD HH:mm:ss'));
				//04.10.2024 -- ранее тут было добавлние 3 часов -- почему 3 уже никто не помнит!
			}
		}
	}
</script>
<style scoped>
	.ReDateRange{
		display: flex;
		align-items: center;
	}
	.ReDateRange > * {display: inline-block;}
	.ReDateRange .range_separator{margin: 0 5px;}
</style>
